import { useQuery } from "@tanstack/react-query";
import { GoalsKeys } from "web_myplann/Api/Goals/GoalsKeys";
import { getGoalIdV2 } from "web_myplann/Infrastructure/Api/Api";
import { processResponse } from "web_myplann/Infrastructure/Api/ApiUtils";

export const useGoalDetailQuery = (
	id: number,
	options?: { enabled?: boolean },
) => {
	return useQuery({
		queryKey: GoalsKeys.detail(id),
		queryFn: processResponse(() => getGoalIdV2(id)),
		enabled: options?.enabled,
	});
};
